import React from 'react';

import SwaggerUI from 'swagger-ui-react';
import "swagger-ui-react/swagger-ui.css";
import swaggerJson from "../../../swagger.json";

export const ApiPage = () => {

    return (
        <>
            <SwaggerUI
                spec={swaggerJson}
            />
        </>
    );
}